export default __webpack_public_path__ + "static/media/Setting.16d85b6b.png";